import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class UiErrorService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translateService = inject(TranslateService);

  public showUnexpectedHttpError(status: number): void {
    this.snackBar.open(this.translateService.instant(this.getMessageKey(status)), undefined, {
      duration: 5000,
    });
  }

  private getMessageKey(status: number): string {
    if (status === 0) {
      return 'http_errors.network';
    }

    if (status === 403) {
      return 'http_errors.forbidden';
    }

    if (status >= 500) {
      return 'http_errors.server';
    }

    return 'http_errors.default';
  }
}
